module.exports = __webpack_public_path__ + "static/brotzeit-mobile-8402180226964deddc2f85c21df4b3de.jpg";